
export const MODULE_NAME = 'notifications'
